export default "<p>admin-sycac-profile works!</p>\n";